const fields = [
  {
    key: 'name',
    type: 'input',
    templateOptions: {
      label: 'name',
      attrs: { 'data-testid': 'club-name' }
    }
  },
  {
    key: 'shortName',
    type: 'input',
    templateOptions: {
      label: 'shortName',
      attrs: { 'data-testid': 'club-short-name' }
    }
  },
  {
    key: 'owner',
    type: 'input',
    templateOptions: {
      label: 'owner'
    }
  },
  {
    key: 'email',
    type: 'input',
    templateOptions: {
      label: 'email'
    }
  },
  {
    key: 'phone',
    type: 'phone',
    templateOptions: {
      label: 'phone'
    }
  },
  {
    key: 'website',
    type: 'input',
    templateOptions: {
      label: 'website'
    }
  },
  {
    key: 'fb',
    type: 'input',
    templateOptions: {
      label: 'fb'
    }
  },
  {
    key: 'tw',
    type: 'input',
    templateOptions: {
      label: 'tw'
    }
  },
  {
    key: 'insta',
    type: 'input',
    templateOptions: {
      label: 'insta'
    }
  }
]

export default fields
